export function formatPrice(price) {
  var str = parseInt(price).toString();
  str = str.padStart(Math.ceil(str.length / 3) * 3, ' ').split('');
  for (let i = str.length / 3; i >= 0; i--) {
    str.splice(i * 3, 0, ' ');
  }
  str = str.join('').trim();

  if (parseInt(price) != parseFloat(price)) {
    str += '.' + parseFloat(price).toFixed(2).split('.').pop();
  }

  str += ' ₽';
  
  return str;
}

export function numericText(number, one, two, many) {
  const n = Math.abs(number) % 100;
  if (n > 10 && n< 20) {
    return many;
  } else if (n % 10 > 1 && n % 10 < 5) {
    return two;
  } else if (n % 10 === 1) {
    return one;
  } else {
    return many;
  }
}